import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const ChevronLeftLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M14 6L8 12L14 18", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
ChevronLeftLine.iconName = 'chevron-left';
ChevronLeftLine.displayName = 'ChevronLeftLine';
export default ChevronLeftLine;
